import React from 'react';
import CONFIG from '../../../config';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Button from '@mui/material/Button';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';
import EmailIcon from '@mui/icons-material/Email';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WidgetSnackbar from '../../../components/widgets/WidgetSnackbar';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AddHomeIcon from '@mui/icons-material/AddHome';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CodePromo from './CodePromo';


function Configuration() {
  const navigate = useNavigate();
  const [snackSecteur, openSnackSecteur] = WidgetSnackbar("Secteurs sauvegardés");
  const [snackMobili, openSnackMobili] = WidgetSnackbar("(Dés)Activation Mobili-Pass sauvegardé");
  const [snackMail, openSnackMail] = WidgetSnackbar("Mail sauvegardé");

  const [roleClient, setRoleClient] = React.useState(null);
  const [roleCommercial, setRoleCommercial] = React.useState(null);
  const [roleLecture, setRoleLecture] = React.useState(null);
  const [roleEcriture, setRoleEcriture] = React.useState(null);
  const [roleComptabilite, setRoleComptabilite] = React.useState(null);

  const [listeSecteurs, setListeSecteurs] = React.useState(null);
  const [mobiliPass, setMobiliPass] = React.useState(null);
  const [configuration, setConfiguration] = React.useState(null);

  const [codePromo, setCodePromo] = React.useState(null);
  const [valueCode, setValueCode] = React.useState(null);
  const [codeComm, setCodeComm] = React.useState(null);

  const [typeMail, setTypeMail] = React.useState(null);
  const [objetMail, setObjetMail] = React.useState(null);
  const [corpsMail, setCorpsMail] = React.useState(null);

  const formMail = [
    [typeMail, setTypeMail],
    [objetMail, setObjetMail],
    [corpsMail, setCorpsMail],
  ];


  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_configuration', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setConfiguration(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  React.useEffect(() => {
    if (configuration !== null) {
      setObjetMail((s) => ({ ...s, value: configuration[typeMail?.value]?.objet, error: false }));
      setCorpsMail((s) => ({ ...s, value: configuration[typeMail?.value]?.corps, error: false }));
    }
  }, [typeMail]);

  
  const saveSecteurs = () => {
    let payload = { secteurs: listeSecteurs.value };

    axios.post(CONFIG.API_URL + '/api/set_secteurs', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            // alert("Secteurs ajoutés.");
            openSnackSecteur();
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }

  const saveMobilipass = () => {
    let payload = { mobili_on: mobiliPass.value };

    axios.post(CONFIG.API_URL + '/api/set_mobili_on', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            // alert("Secteurs ajoutés.");
            openSnackMobili();
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }


  const saveMail = () => {
    var payload = {};

    for (var i = 0; i < formMail.length; i++) {
      let [field, setField] = formMail[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/set_mail', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            openSnackMail();
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }


  return (
    <>
      {snackSecteur}
      {snackMobili}
      {snackMail}
      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1><b>Pré-création</b> d'un compte</h1>
          </div>
        </div>

        <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-10 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <AddModeratorIcon fontSize='large'></AddModeratorIcon>
            </div>
            <div>
              <h2>Rôles</h2>
            </div>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          <div className='col-span-2 w-full mb-4'>
            <WidgetCheckbox state={roleClient} setState={setRoleClient} id={'role_client'} text={"Client"} value={true} />
          </div>

          <div className='col-span-2 w-full mb-4'>
            <WidgetCheckbox state={roleCommercial} setState={setRoleCommercial} id={'role_commercial'} text={"Commercial"} />
          </div>

          <div className='col-span-2 w-full mb-4'>
            <WidgetCheckbox state={roleLecture} setState={setRoleLecture} id={'role_comptable'} text={"Lecture admin"} />
          </div>

          <div className='col-span-2 w-full mb-4'>
            <WidgetCheckbox state={roleEcriture} setState={setRoleEcriture} id={'role_admin_read'} text={"Ecriture admin"} />
          </div>

          <div className='col-span-2 w-full mb-4'>
            <WidgetCheckbox state={roleComptabilite} setState={setRoleComptabilite} id={'role_admin_write'} text={"Comptabilité"} />
          </div>
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <Button variant='contained' onClick={() => {
              let payload = {
                role_client: roleClient.value,
                role_commercial: roleCommercial.value,
                role_comptable: roleLecture.value,
                role_admin_read: roleEcriture.value,
                role_admin_write: roleComptabilite.value
              };

              axios.post(CONFIG.API_URL + '/api/user_pre_creation', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      navigate("/intranet/fiche/" + response.data._id)
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            }}>
              Pré-créer le compte
            </Button>
          </div>
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <hr className='w-full border-gray-400 px-6'></hr>
          </div>
        </div>
      </div>



      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1>Liste des <b>secteurs</b></h1>
          </div>
        </div>

        <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-10 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <MyLocationIcon fontSize='large'></MyLocationIcon>
            </div>
            <div>
              <h2>Secteurs</h2>
            </div>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          {configuration !== null &&
            <div className='col-span-10 w-full mb-4'>
              <WidgetInputTextList state={listeSecteurs} setState={setListeSecteurs} id={'liste_secteurs'} text={"Liste des secteurs"} value={configuration.secteurs.sort()} />
            </div>
          }
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <Button variant='contained' onClick={saveSecteurs}>
              Sauvegarder
            </Button>
          </div>
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <hr className='w-full border-gray-400 px-6'></hr>
          </div>
        </div>
      </div>



      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1>Activer <b>Mobili-Pass</b></h1>
          </div>
        </div>

        <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-10 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <AddHomeIcon fontSize='large'></AddHomeIcon>
            </div>
            <div>
              <h2>Mobili-Pass</h2>
            </div>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          {configuration !== null &&
            <div className='col-span-10 w-full mb-4'>
              <WidgetCheckbox state={mobiliPass} setState={setMobiliPass} id={'mobili_pass'} text={"Activer le Mobili-Pass"} value={configuration.mobili_on} />
            </div>
          }
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <Button variant='contained' onClick={saveMobilipass}>
              Sauvegarder
            </Button>
          </div>
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <hr className='w-full border-gray-400 px-6'></hr>
          </div>
        </div>
      </div>



      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1>Liste des <b>codes promo</b></h1>
          </div>
        </div>

        <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-10 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <ConfirmationNumberIcon fontSize='large'></ConfirmationNumberIcon>
            </div>
            <div>
              <h2>Codes promo</h2>
            </div>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          {configuration !== null &&
            <>
              <div className='col-span-3 w-full mb-4'>
                <WidgetInputText state={codePromo} setState={setCodePromo} id={'code_promo'} text={"Code"} />
              </div>
              <div className='col-span-3 w-full mb-4'>
                <WidgetInputText state={valueCode} setState={setValueCode} id={'value_code'} text={"Valeur"} />
              </div>
              <div className='col-span-2 w-full mb-4'>
                <WidgetCheckbox state={codeComm} setState={setCodeComm} id={'code_comm'} text={"Pour commercial"} value={true} />
              </div>
              <div className='col-span-2 w-full mb-4 text-center content-center grid'>
                <Button variant='contained' disabled={configuration?.codes_promos.map(x => x.code).includes(codePromo?.value)} onClick={() => {
                  let payload = {
                    code: codePromo.value,
                    valeur: valueCode.value,
                    commercial: codeComm.value,
                  }
                  axios.post(CONFIG.API_URL + '/api/add_codepromo', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                  .then((response) => {
                    switch (response.status) {
                      case 200:
                        setConfiguration(response.data);
                        break;
            
                      default:
                        break;
                    }
                  })
                  .catch((e) => {
                    let response = e.response;
            
                    if (response === undefined) {
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      return;
                    }
            
                    switch (response.status) {
                      default:
                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                        break;
                    }
                  });
                }}>
                  Ajouter
                </Button>
              </div>
            </>
          }

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          {configuration !== null &&
            (configuration.codes_promos.map((x, i) => <CodePromo key={i} id={i} configuration={configuration} setConfiguration={setConfiguration} code={x.code} value={x.valeur} commercial={x.commercial}></CodePromo>))
          }
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <hr className='w-full border-gray-400 px-6'></hr>
          </div>
        </div>
      </div>



      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1>Modèles de <b>mails</b></h1>
          </div>
        </div>

        <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-10 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <EmailIcon fontSize='large'></EmailIcon>
            </div>
            <div>
              <h2>Mails</h2>
            </div>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <hr></hr>
          </div>

          <div className='col-span-10 w-full mb-4'>
            <WidgetSelect state={typeMail} setState={setTypeMail} id={'type_mail'} text={"Type de mail"}
              options={{
                'mail_verify_email': "Vérification email",
                'mail_new_password': "Nouveau mot de passe",
                'mail_creation_client_mail': "Précréation",
                'mail_creation_mail_pro': "Précréation compte pro",
                'mail_precrea_relance3j': "Précréation relance 3j",
                'mail_precrea_relance7j': "Précréation relance 7j",
                'mail_precrea_relance14j': "Précréation relance 14j",
                'mail_precrea_relance21j': "Précréation relance 21j",
                'mail_precrea_relance28j': "Précréation relance 28j",
                'mail_informer_admin_read': "Dossier reçu admin",
                'mail_verifie_dossier': "Dossier à vérifier",
                'mail_rejet': "Rejet de documents",
                'client_valide_admin': "Client validé (notif admin)",
                'mail_notif_commercial_proposition': "Notif commercial proposition",
                'mail_notif_commercial_attribution': "Notif commercial attribution",
                'mail_notif_commercial_accepte': "Notif commercial accepte proposition",
                'mail_notif_commercial_rejet': "Notif commercial rejet proposition",
                'mail_cerfa': "Cerfa",
                'mail_finaliser_relance': "Finaliser dossier relance",
                'mail_avis_google': "Avis google",
                'admin_commercial_non_paye': "Commercial non-payé (notif admin)",
              }}
            />
          </div>

          {configuration !== null &&
            <>
              <div className='col-span-10 w-full mb-4'>
                <WidgetInputText state={objetMail} setState={setObjetMail} id={'objet'} text={"Objet"} value={configuration[typeMail.value]?.objet} />
              </div>

              <div className='col-span-10 w-full mb-4'>
                <WidgetInputText state={corpsMail} setState={setCorpsMail} id={'corps'} text={"Corps"} multiline={true} value={configuration[typeMail.value]?.corps} />
              </div>
            </>
          }
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-12 w-full text-right'>
            <Button variant='contained' onClick={saveMail}>
              Sauvegarder
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Configuration;